import React, { useContext } from 'react';
import BaseNav from '../../routing/BaseNav';
import { AppContext } from '../../context/app-context';
import './style.css';
import { mergeNavigationArray } from '../../routing/LandingNav';
import { getUserBasedNavOptions } from "../../routing/nav-options";
import { useFilteredNav } from "../../hooks/routing/useFilteredNav";
import { determineRightNav } from '../../routing/nav/DefaultNav';

const AboutNavHeader = () => {
    const context = useContext(AppContext)
    const { user } = context;
    
    // getUserBasedNavOptions/determineRightNav already fall back to the
    // anonymous (logged-out) nav options when user is null/undefined, so we
    // must not short-circuit to [] here or logged-out users get a blank nav.
    const leftNav = getUserBasedNavOptions(user);
    const rightNav = determineRightNav(user);

    const filteredNav = useFilteredNav(user, mergeNavigationArray(leftNav, rightNav));

    return (
        <header className='ss-about-nav-header header-background'>
            <BaseNav
                rightNavOptions={filteredNav}
                fontColorOverride={true}
                logoUrl={"/app-images/logo/secure-space_white-logo_WTG.svg"}
            />
        </header>
    );
};

export default AboutNavHeader;
